import * as React from 'react';
import ScrollContainer from 'react-indiana-drag-scroll';
import { NavLink, Outlet } from 'react-router-dom';
import uncPolyLargeLogo from '../../assets/images/unc poly logo-large-01.svg';

import './Settings.scss';
export interface ISettingsProps {
}

export function Settings(props: ISettingsProps) {


    const smallNavItemStyles = 'font-bold dark:font-semibold xs:text-xs xsm:text-xs sm:text-base xs:px-2 whitespace-nowrap sm:px-4 settings_small_nav_icon pb-4';

    return (
        <div className="relative overflow-hidden min-h-screen">
            <div className="
        pt-[64px]
        sm:max-w-[570px] sm:pt-[80px]
        md:max-w-[660px]
        lg:max-w-[870px]
        xl:max-w-[1100px]
        2xl:max-w-[1336px]
        3xl:max-w-[1436px]
        mx-auto xs:mt-6 sm:mt-10 md:mt-24 pb-28 md:pb-24 px-4 settings_main_box">
                <div className="text-left">
                    <h1 className="xs:text-2xl xl:text-3xl font-extrabold text-cusBlack dark:text-white">Settings</h1>

                    <ScrollContainer
                        nativeMobileScroll={true}
                        horizontal={true}
                        className="scroll-container flex justify-start items-end xs:mt-4 sm:mt-8 relative overflow-auto">
                        <NavLink to="/settings/profile" className={({ isActive }) => (isActive ? `${smallNavItemStyles} active` : `${smallNavItemStyles}`)}>
                            Profile
                        </NavLink>
                        <NavLink to="/settings/notifications" className={({ isActive }) => (isActive ? `${smallNavItemStyles} active` : `${smallNavItemStyles}`)}>
                            Notifications
                        </NavLink>
                        <NavLink to="/settings/offers" className={({ isActive }) => (isActive ? `${smallNavItemStyles} active` : `${smallNavItemStyles}`)}>
                            Offers
                        </NavLink>
                        <NavLink to="/settings/payment" className={({ isActive }) => (isActive ? `${smallNavItemStyles} active` : `${smallNavItemStyles}`)}>
                            Payment
                        </NavLink>
                        <NavLink to="/settings/accountSupport" className={({ isActive }) => (isActive ? `${smallNavItemStyles} active` : `${smallNavItemStyles}`)}>
                            Account Support
                        </NavLink>
                        <NavLink to="/settings/earnings" className={({ isActive }) => (isActive ? `${smallNavItemStyles} active` : `${smallNavItemStyles}`)}>
                            Earnings
                        </NavLink>
                        <div className="w-full border-2 border-[#DEDEDE] dark:border-[#201753] flex-1 align-bottom"></div>
                    </ScrollContainer>
                </div>

                <div className="absolute bottom-0 hidden md:block
            xs:w-[367px] xs:right-[-119px] xs:bottom-[-20px]
            md:w-[397px] md:right-[-139px] md:bottom-[-29px]
            xl:w-[479px] xl:right-[-162px] xl:bottom-[-31px]
            3xl:w-[550px] 3xl:right-[-177px] 3xl:bottom-[-41px] select-none z-0
            ">
                    <img src={uncPolyLargeLogo} alt="" className="w-full h-full" />
                </div>
                <Outlet />
            </div>
        </div>
    );
}
